// extracted by mini-css-extract-plugin
export var plan_right_list = "index-module--plan_right_list--1cb45";
export var plan_right_title = "index-module--plan_right_title--84503";
export var plan_right_wrapper = "index-module--plan_right_wrapper--9ccdb";
export var right_item = "index-module--right_item--8d6e5";
export var right_item_text = "index-module--right_item_text--43255";
export var right_tag = "index-module--right_tag--5ff85";